var _dropdownSelectStyle;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { StyleSheet, color, font } from "../../../../styles/theme";
export var PAGINATION_HEIGHT = 49;
export var TOOLBAR_HEIGHT = 46;
export var TOOLBAR_DROPDOWN_LINE_HEIGHT = '44px';
export var SMALL_TOOL_WIDTH = 48;
export var TOOL_MARGIN = 12;
export var focusedStyle = {
  border: "1px solid ".concat(color.primary)
};
export default StyleSheet.create({
  focused: focusedStyle,
  noResultCell: {
    textAlign: 'center'
  },
  toolbar: {
    display: 'flex',
    flexWrap: 'nowrap',
    height: TOOLBAR_HEIGHT
  },
  searchBarWrapper: {
    height: TOOLBAR_HEIGHT,
    display: 'flex',
    flex: 1,
    border: "1px solid ".concat(color.divider),
    cursor: 'text'
  },
  searchBarInput: {
    'flex': 1,
    'margin': '9px 0',
    'lineHeight': '24px',
    'border': 'none',
    'fontSize': font.sm,
    ':focus': {
      outline: 'none'
    },
    '::placeholder': {
      color: color.secondaryText,
      opacity: 1
    }
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  searchBarIconWrapper: {
    height: '44px',
    margin: '0 12px'
  },
  dropdownWrapper: {
    marginLeft: TOOL_MARGIN
  },
  dropdownValue: {
    lineHeight: TOOLBAR_DROPDOWN_LINE_HEIGHT
  },
  dropdownPlaceholder: {
    lineHeight: TOOLBAR_DROPDOWN_LINE_HEIGHT,
    color: color.secondaryText
  },
  selectAllWrapper: {
    minWidth: SMALL_TOOL_WIDTH
  },
  actionButtonMargin: {
    marginRight: TOOL_MARGIN
  }
});
export var dropdownSelectStyle = (_dropdownSelectStyle = {
  border: 'none',
  borderRadius: 0,
  fontSize: font.sm,
  boxShadow: 'none',
  cursor: 'pointer'
}, _defineProperty(_dropdownSelectStyle, "border", "1px solid ".concat(color.divider)), _defineProperty(_dropdownSelectStyle, "height", TOOLBAR_HEIGHT), _dropdownSelectStyle);
export var dropdownOption = {
  lineHeight: '34px',
  padding: '6px 10px',
  fontSize: font.sm,
  cursor: 'pointer'
};
export var dropdownOptionFocused = {
  color: color.white,
  backgroundColor: color.primary
};
export var menuContainerStyle = _objectSpread({}, focusedStyle, {
  borderRadius: '0'
});
export var actionButtonStyle = {
  height: TOOLBAR_HEIGHT
};
export var iconActionButtonStyle = _objectSpread({}, actionButtonStyle, {
  width: SMALL_TOOL_WIDTH,
  border: 'none'
});
export var svgProps = {
  size: 20,
  hoverColor: color.primary
};
export var disabledSvgProps = {
  color: color.lightGrayText,
  hoverColor: color.lightGrayText
};
export var disabledButtonStyle = {
  backgroundColor: 'transparent'
};